module.exports = __webpack_public_path__ + "img/support-manager.ed6ad3d9.png";